import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Store, Package, Tag, Ticket, Newspaper, Calendar, Briefcase, Home, RefreshCw,
} from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const CARDS = [
  { key: "businesses", label: "Empresas", icon: Store, to: "/admin/r/businesses" },
  { key: "products", label: "Produtos", icon: Package, to: "/admin/r/products" },
  { key: "promotions", label: "Promoções", icon: Tag, to: "/admin/r/promotions" },
  { key: "coupons", label: "Cupons", icon: Ticket, to: "/admin/r/coupons" },
  { key: "news", label: "Notícias", icon: Newspaper, to: "/admin/r/news" },
  { key: "events", label: "Eventos", icon: Calendar, to: "/admin/r/events" },
  { key: "jobs", label: "Vagas", icon: Briefcase, to: "/admin/r/jobs" },
  { key: "rentals", label: "Imóveis", icon: Home, to: "/admin/r/rentals" },
];

const Dashboard = () => {
  const [stats, setStats] = useState({});

  const load = () => api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const reseed = async () => {
    if (!window.confirm("Recriar todos os dados de demonstração? Isso substitui o conteúdo atual.")) return;
    try {
      await api.post("/admin/seed");
      toast.success("Dados de demonstração recriados");
      load();
    } catch (e) {
      toast.error("Erro ao recriar dados");
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold font-heading text-slate-900">Dashboard</h1>
          <p className="text-sm text-muted-foreground">Visão geral do seu guia</p>
        </div>
        <button onClick={reseed} data-testid="reseed-btn" className="flex items-center gap-2 text-sm font-semibold text-slate-600 border border-border rounded-full px-4 py-2 hover:bg-slate-100 transition-colors">
          <RefreshCw className="w-4 h-4" /> Dados demo
        </button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.key} to={c.to} data-testid={`stat-${c.key}`} className="bg-white rounded-2xl border border-border p-4 hover:shadow-md hover:border-primary/40 transition-all">
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-3">
                <Icon className="w-5 h-5 text-primary" />
              </div>
              <div className="text-3xl font-bold font-heading text-slate-900">{stats[c.key] ?? 0}</div>
              <div className="text-sm text-muted-foreground">{c.label}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Dashboard;
